import { Theme } from "@workspace/mobile";
import { dmnIdentity } from "../dmnIdentity";
import { dmnStorage } from "../dmnStorage";
import { getEnvironmentProps } from "../environment";
import { postToNative, requestFromNative } from "./postToNative";

export const getBuildNumber = async (): Promise<string> => {
  if (!window.ReactNativeWebView) {
    return "Web view";
  }

  return (await requestFromNative<string>("getBuildNumber")) ?? "";
};

export const consoleLog = async (message: string): Promise<void> => {
  if (!window.ReactNativeWebView) {
    console.log(message);
    return;
  }

  postToNative({
    actionType: "consoleLog",
    message: message
  });
};

export const forceReload = async (): Promise<void> => {
  if (!window.ReactNativeWebView) {
    history.replaceState({}, "", "/");
    window.location.reload();
    return;
  }

  postToNative({
    actionType: "forceReload"
  });
};

export const updateColourScheme = async (
  colourScheme: string
): Promise<void> => {
  if (!window.ReactNativeWebView) {
    dmnStorage.add("theme", colourScheme);
    return;
  }

  postToNative({
    actionType: "setColourScheme",
    message: colourScheme.toLowerCase()
  });
};

export const getColourScheme = async (): Promise<Theme> => {
  if (!window.ReactNativeWebView) {
    return (await dmnStorage.get("theme")) ?? "Light";
  }

  const colourScheme =
    (await requestFromNative<string>("getColourScheme")) ?? "dark";

  return (colourScheme.charAt(0).toUpperCase() +
    colourScheme.slice(1)) as Theme;
};

type EnvironmentName = "Prod" | "PreProd" | "Staging" | "Demo";
export const getEnvironment = async (): Promise<EnvironmentName> => {
  if (!window.ReactNativeWebView) {
    const token = await dmnIdentity.getAccessToken();
    const environmentVars = getEnvironmentProps(token);
    return environmentVars.ENVIRONMENT === "Production" ? "Prod" : "PreProd";
  }

  return (
    (await requestFromNative<EnvironmentName>("getEnvironment")) ?? "PreProd"
  );
};
